<!--
Author: TangChen
Date: 2018-09-17
Desc: 菜单组件，由index.js 配置引入
-->
<template>
    <div class="comp-menu comp">
        <el-menu
            :default-active="menuCheck"
            class="el-menu-out"
            mode="horizontal"
            :unique-opened="true"
            router
        >
            <el-row>
                <el-col v-for="item of menus" :key="item.i" :span="4">
                    <el-submenu v-if="item.menu" :index="item.i">
                        <template slot="title">
                            <!-- <i :class="item.icon"></i> -->
                            <!-- <icon-combo :data="icon" :iconCla="item.icon"></icon-combo> -->
                            <span>{{ item.name }}</span>
                        </template>
                        <template v-if="item.menu">
                            <template v-for="items in item.menu">
                                <el-menu-item
                                    v-if="(info.professionflag==='0'||items.link!=='/risk') && (info.isCC === '1' || items.link !== '/profitqry') && (info.isCC === '1' || items.link !== '/service') && (info.isetf === '1' || items.link !== '/etflist')"
                                    :key="items.name"
                                    :index="items.link"
                                >
                                    {{ items.name }}
                                </el-menu-item>
                            </template>
                        </template>
                    </el-submenu>
                    <el-menu-item v-else :index="item.link" class="grouped">
                        <!-- <icon-combo :data="icon" :iconCla="item.icon"></icon-combo> -->
                        <span slot="title">{{ item.name }}</span>
                    </el-menu-item>
                </el-col>
            </el-row>
        </el-menu>
    </div>
</template>
<script>
export default {
    name: "NavMenu",
    props: {
        active: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            menus: [
                { icon: "fa fa-home", name: "资产首页", i: "1", link: "/home" },
                {
                    icon: "fa fa-jpy",
                    name: "现金宝",
                    i: "2",
                    link: "/currencyfund"
                },
                {
                    icon: "fa fa-shopping-cart",
                    name: "基金交易",
                    i: "3",
                    menu: [
                        { name: "基金超市", link: "/fund" },
                        /* { name: "组合购买", link: "/combofund" }, */
                        { name: "基金转换", link: "/cfund" },
                        // { name: "预约购买", link: "/orderfund" },
                        { name: "预约记录", link: "/preselllist" },
                        // { name: "预约赎回", link: "/orderselllist" },
                        // { name: "我的预约", link: "/myorder" },
                        { name: "交易记录", link: "/traderecord" },
                        { name: "分红信息明细", link: "/dividendInfo" }
                        // { name: "补券信息", link: "/etflist" } ,
                        // { name: "盈亏查询", link: "/profitqry" }
                        // { name: "账户查询", link: "/accountSearch" }
                    ]
                },
                {
                    icon: "fa fa-chart-line",
                    name: "基金定投",
                    i: "4",
                    menu: [
                        { name: "定投产品", link: "/gfund" },
                        { name: "我的定投", link: "/myplan" }
                    ]
                },
                // {
                //     icon: "fa fa-gem",
                //     name: "专户理财",
                //     i: "5",
                //     menu: [
                //         { name: "专户理财产品", link: "/privatefund" },
                //         { name: "我的专户理财", link: "/private" },
                //         { name: "信息披露", link: "/infoPublish" }
                //     ]
                // },
                {
                    icon: "fa fa-user",
                    name: "个人中心",
                    i: "6",
                    menu: [
                        { name: "信息中心", link: "/info" },
                        { name: "我的银行卡", link: "/bank" },
                        { name: "风险测评", link: "/risk" },
                        { name: "安全中心", link: "/securitycenter" },
                        // { name: "服务定制", link: "/service" },
                        { name: "对账单信息", link: "/statement" },
                        { name: "投资者信息收集", link: "/infoCollection" },
                        // { name: "投资者转换", link: "/invchange" },
                        { name: "个人税收居民类型声明", link: "/info/taxeslist" },
                        { name: "政策法规", link: "/policyAndLaw" }
                    ]
                }
            ],
            icon: {
                w: "24"
            },
            menuCheck: "/home",
            info: {}
        };
    },
    mounted() {
        if(this.$cache.getXjbCode() === ""){
            this.menus = this.menus.filter(item=>{
                return item.i !== "2";
            });
        }
        this.info = this.$cache.getUser();
        // 获取当前选中菜单
        const _x = this.$route.path;
        const x = _x.split("/");
        // 菜单自动选中
        if (x.length > 2) {
            this.menuCheck = "/" + x[1];
        } else {
            this.menuCheck = _x;
        }
    },
    methods: {}
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-menu {
    outline: none!important;
    .el-menu.el-menu-out {
        outline: none!important;
        border: none;
        width: 900px;
        margin: 0 auto;
        background: inherit;
        .el-row{outline: none;}
        .el-menu-item.grouped,
        .el-submenu .el-submenu__title {
            height: auto;
            line-height: 48px;
            text-align: center;
            font-size: $f20;
            padding: 15px 0;
            color: $text-color2;
            i {
                color: inherit;
                display: inline-block;
                text-align: center;
                margin-right: 4px;
                display: none;
            }
            span{display: inline-block;height: 49px;}
            &:hover {
                background: $bg2;
                border-color: $color-a-m;
                color: $color-a;
            }
        }
        .el-menu-item.is-active,
        .el-submenu.is-active .el-submenu__title{
            border-color: $color-a-m;
            color: $color-a;
            span{border-bottom: 2px solid $color-a;position: relative;height: 47px;}
            span:after{
                content: "";
                width: 0;
                height: 0;
                position: absolute;
                bottom: 0;
                left: 50%;
                border: 5px solid transparent;
                border-bottom-color:$color-a;
                z-index: 10;
                margin-left: -5px;
            }
        }
    }
}
</style>
